import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { PlayVideoAction, OpenImageAction } from './media.actions';

@Injectable()
export class MediaService {
  constructor(private store: Store<any>) {}

  playVideo(url: string) {
    this.store.dispatch(new PlayVideoAction(url));
  }

  openImage(url: string) {
    this.store.dispatch(new OpenImageAction(url));
  }
}
